const BOOKS_ROOT = "/books"

export const ROUTES = {
  HOME: "/",
  BOOK_DETAILS: `${BOOKS_ROOT}/:id`,
  BOOK_OPTIMIZE: `${BOOKS_ROOT}/:id/optimize`,
  BOOK_TAGS: `${BOOKS_ROOT}/:id/tags`,
  BOOK_COLLECTIONS: `${BOOKS_ROOT}/:id/collections`,
  BOOK_METADATA_SOURCE: `${BOOKS_ROOT}/:id/metadata/:source`,
  COLLECTION_DETAILS: "/collections/:id",
  PROFILE: "/profile",
  NOTIFICATIONS: "/profile/notifications",
  SECURITY: "/profile/security",
  SECRETS: "/profile/secrets",
  SETTINGS: "/profile/settings",
  STATISTICS: "/profile/statistics",
  MANAGE_STORAGE: "/profile/manage-storage",
  INTEGRATIONS: "/integrations",
  INTEGRATION_DROPBOX: "/integrations/dropbox",
  INTEGRATION_GOOGLE: "/integrations/google",
  INTEGRATION_KOREADER: "/integrations/koreader",
  INTEGRATION_ONE_DRIVE: "/integrations/one-drive",
  INTEGRATION_SERVER: "/integrations/server",
  INTEGRATION_SYNOLOGY_DRIVE: "/integrations/synology-drive",
  INTEGRATION_WEBDAV: "/integrations/webdav",
  INTEGRATION_CONNECTORS_NEW: "/integrations/:type/connectors/new",
  INTEGRATION_CONNECTORS_EDIT: "/integrations/:type/connectors/:id",
  KOREADER_SYNC_SERVER: "/integrations/koreader/sync-server",
  KOREADER_PROGRESS_SYNC: "/integrations/koreader/progress-sync",
  SYNC: "/sync",
  SYNC_DATASOURCES: "/sync/datasources",
  SYNC_NEW_DATASOURCES: "/sync/new-datasources/:type",
  SYNC_REPORTS: "/sync/reports",
  DATASOURCE_DETAILS: "/sync/datasources/:id",
  LIBRARY_ROOT: "/library",
  LIBRARY_BOOKS: "/library/books",
  LIBRARY_COLLECTIONS: "/library/collections",
  LIBRARY_TAGS: "/library/tags",
  TAG_BOOKS: "/library/tags/:id/books",
  COLLECTION_BOOKS: "/collections/:id/books",
  LOGIN: "/login",
  LOGIN_MAGIC_LINK: "/login/magic-link",
  SESSION_EXPIRED: "/session-expired",
  SIGN_UP: "/signup",
  SIGN_UP_COMPLETE: "/signup/complete",
  READER: "/reader/:id",
  SEARCH: "/search",
  SEARCH_RESULTS: "/search/:search/:type",
  PROBLEMS: "/problems",
} as const
